import i18n from '@/plugins/i18n'
export default {
  browse: {
    table: {
      headers: [{
          text: i18n.t("model.prop.no"),
          value: 'index',
          sortable: false,
        },
        {
          text: 'Key',
          value: 'key',
        },
        {
          text: 'Status',
          value: 'automationStatus',
        },
        {
          text: 'Created',
          value: 'dateCreated',
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: 'Info',
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: 'Key',
          value: 'key',
        },
        {
          text: 'Status',
          value: 'automationStatus',
        },
        {
          text: "Api URL",
          value: "apiUrl",
        },
        {
          text: "Body",
          value: "requestBody",
        },
        {
          text: "Data",
          value: "data",
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: false,
  edit: false,
  delete: true,
}